module.exports = __webpack_public_path__ + "img/IBDPro-Call.6acc8146.png";